import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'

import Meta from "../components/layout/Meta";
import { Path, PathGenerator } from "../constants/path";
import { ExternalPath } from "../constants/path";
import { Link, Button } from "../components/util/Clickable";
import { Image } from "../components/util/Image";

import Search from "../components/view/Search";
import FacilityCard from "../components/view/FacilityCard";
import Facility from "../components/view/Facility";
import PlanList from "../components/view/PlanList";

import { getFacility, getFacilities, getPlans } from "../actions/facility";
declare var UIkit;

class FacilityScreen extends Component {

  state = {
    facility: null,
    query: null,
    fail: false,
    facilities: null,
    plans: null
  }

  componentWillMount = () => {
    const query = qs.parse(this.props.location.search.replace("?", ""));
    this.setState({
      query: query
    }, () => {
      this.load(this.props.match.params.facilityId);
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if( this.props.location.search != nextProps.location.search || this.props.location.pathname != nextProps.location.pathname ){
      const query = qs.parse(nextProps.location.search.replace("?", ""));
      this.setState({
        query: query
      }, () => {
        this.load(nextProps.match.params.facilityId);
      });
    }
  }

  load = (facilityId) => {
    this.props.actions.getFacility(facilityId).then( ({value, action}) => {
      if( value.status < 300 ){
        this.setState({
          facility: value.data,
          fail: false
        });  
        this.props.actions.getFacilities( {small_area_id: value.data.small_area_id} ).then( ({value, action}) => {
          if( value.status < 300 ){
            this.setState({
              facilities: value.data
            }); 
          }
        });
        const query = qs.parse(this.props.location.search.replace("?", ""));
        this.props.actions.getPlans( value.data.member_id, query ).then(({value}) => {
          this.setState({
            plans: value.data ? value.data.filter( (d) => {
              return !d.error;
            }): []
          }, () => {
            // #plansで指定されている場合はプランエリアまでスクロール
            if( this.plan && this.props.location.hash == "#plans" ){
              UIkit.scroll(this.dummy, {offset: 64}).scrollTo(this.plan);  
            }
          });
        }).catch( error => {
          this.setState({
            plans: []
          });
        });
      }else{
        this.setState({
          fail: true
        });  
      }
    }).catch( error => {
      this.setState({
        fail: true
      });
    });
  }

  renderBread = () => {
    var links = [];
    if(
      this.state.facility.small_area 
      && this.state.facility.small_area.large_area
      && this.state.facility.small_area.large_area.prefecture
      && this.state.facility.small_area.large_area.prefecture.region
    ){
      var query = {
        region_id: this.state.facility.small_area.large_area.prefecture.region.id,
      }
      links.push({
        label: this.state.facility.small_area.large_area.prefecture.region.label, 
        url: Path.facilities.url + "?" + qs.stringify(query)
      });

      query = {
        region_id: this.state.facility.small_area.large_area.prefecture.region.id,
        prefecture_id: this.state.facility.small_area.large_area.prefecture.id,
      }
      links.push({
        label: this.state.facility.small_area.large_area.prefecture.label, 
        url: Path.facilities.url + "?" + qs.stringify(query)
      });

      query = {
        region_id: this.state.facility.small_area.large_area.prefecture.region.id,
        prefecture_id: this.state.facility.small_area.large_area.prefecture.id,
        large_area_id: this.state.facility.small_area.large_area.id,
      }
      links.push({
        label: this.state.facility.small_area.large_area.label, 
        url: Path.facilities.url + "?" + qs.stringify(query)
      });
    }

    links.push({
      label: this.state.facility.name, url: PathGenerator.facility(this.state.facility.id)
    });

    return (
      <ul className="uk-breadcrumb">
        <li><a href="http://spa-misasa.jp/">トップページ</a></li>
        <li><Link to={Path.facilities.url}>施設一覧</Link></li>
        {
          links.map( (link, index) => {
            return (
              <li key={index}>
                <Link to={link.url}>{link.label}</Link>
              </li>
            );
          })
        }
      </ul>
    );
  }

  render = () => {
    return (
      <div>
        <Meta />
        <div className="uk-section">
          <div className="uk-container uk-container-small">
            <div data-uk-grid className="uk-grid-large">
              <div className="uk-width-expand">
                {
                  (!this.state.fail && ( this.state.facility != null ) ) && this.renderBread()
                }
                <hr />
                {( () => {
                  if( this.state.fail ){
                    return (
                      <div className="uk-width-1-1 uk-height-large uk-position-relative">
                        <div className="uk-position-center">
                          <h2 className="uk-text-center">404 Not Found.</h2>
                          <p className="uk-text-center">施設が存在しません。</p>
                        </div>
                      </div>
                    ); 
                  }else if( this.state.facility == null ){
                    return (
                      <div className="uk-width-1-1 uk-height-large uk-position-relative">
                        <div className="uk-position-center">
                          <span data-uk-spinner="ratio: 3"></span>
                        </div>
                      </div>
                    ); 
                  }else {
                    return (
                      <div className="uk-margin-medium">
                        <Facility facility={this.state.facility} />
                      </div>
                    ) 
                  }
                })()}
                <div ref={plan => this.plan = plan} >
                {(()=>{
                  if( this.state.plans == null ){
                    return (
                      <div className="uk-width-1-1 uk-height-large uk-position-relative">
                        <div className="uk-position-center">
                          <span data-uk-spinner="ratio: 2"></span>
                        </div>
                      </div>
                    ); 
                  }else {
                    return (
                      <div className="uk-margin-medium">
                        <h2>
                          {this.state.facility.name}で利用可能なプラン
                        </h2>
                        <PlanList facility={this.state.facility} plans={this.state.plans} />
                      </div>
                    ) 
                  }
                })()}
                </div>
                {
                  this.state.facilities && (
                    <div className="uk-margin-medium">
                      <h2>
                        その他の【{ this.state.facility.small_area.label }】の施設
                      </h2>
                      {
                        this.state.facilities.map( (facility, index) => {
                          return (
                            <div key={index} className="uk-margin-small">
                              <FacilityCard facility={facility} noLoad={true} />
                            </div>
                          );
                        })
                      }
                      <div className="uk-margin uk-text-center">
                        <Link className="uk-button uk-button-secondary uk-width-large@s" to={Path.facilities.url + this.props.location.search}>
                          もっと見る
                        </Link>
                      </div>
                    </div>
                  )
                }
              </div>
              <div className="uk-width-large@s uk-width-1-1 uk-flex-first@s">
                <Search />
              </div>
              <div ref={dummy => this.dummy = dummy}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getFacility: (data) => dispatch(getFacility(data)),
    getFacilities: (data) => dispatch(getFacilities(data)),
    getPlans: (...data) => dispatch(getPlans(...data)),
  }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilityScreen))
